import { render, staticRenderFns } from "./tronscanTransferOther.vue?vue&type=template&id=f857f320&scoped=true"
import script from "./tronscanTransferOther.vue?vue&type=script&lang=js"
export * from "./tronscanTransferOther.vue?vue&type=script&lang=js"
import style0 from "./tronscanTransferOther.vue?vue&type=style&index=0&id=f857f320&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f857f320",
  null
  
)

export default component.exports